import { useEffect, useState } from "react";
import ReportsTable from "./reportsTable";
import { Button, Dropdown, Form } from "react-bootstrap";
import { fetchAgentReports, getUsers } from "../../../api/lead";

const Reports = () => {
  const [isLoading, setisLoading] = useState(true);
  const [reportsData, setReportsData] = useState([{'call_logs': [], 'webhook_responses': []}]);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [userList, setUserList] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const fetchUserList = async () => {
    try {
      setisLoading(true);
      const response = await getUsers({ user_type: "Agent" });
      setUserList(response.data); 
    } catch (err) {
      console.error(err);
      // setError(err);
    } finally {
      setisLoading(false);
    }
  };

  const fetchReportData = async () => {
    let data = {
      'user_list': selectedUsers,
      'start_date': startDate,
      'end_date': endDate
    }
    if(selectedUsers.length == 0) {
      alert('Please select Agent for Report')
      return
    }
    if(!startDate || !endDate){
      alert('Please select Date Range')
      return
    }
    try {
      setisLoading(true);
      const response = await fetchAgentReports(data);
      setReportsData(response.data); 
    } catch (err) {
      console.error(err);
      // setError(err);
    } finally {
      setisLoading(false);
    }

  };


  useEffect(() => {
    fetchUserList();
  }, []);

  const handleSelect = (value, type, label) => {
    const filterMap = {
      assignedTo: [selectedUsers, setSelectedUsers],
    };
  
    const [currentValues, setValues] = filterMap[type];
  
    const isSelected = currentValues.some(item => item.value === value);
  
    if (isSelected) {
      setValues(currentValues.filter(item => item.value !== value));
    } else {
      setValues([
        ...currentValues,
        { value, label }
      ]);
    }
  };  

  return isLoading == true ? (
    <div class="d-flex justify-content-center">
      <div class="spinner-border" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
  ) : (
    <div>
      <div className="flex items-center justify-between mt-4 mb-2">
        <h2>Reports</h2>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "16px",
            flexWrap: "wrap",
          }}
        >
          {/* Dropdown */}
          <Dropdown>
            <Dropdown.Toggle
              className="btn-transfer-to"
              variant="primary"
              id="dropdownMenuButton"
            >
              Agent List
            </Dropdown.Toggle>
              <Dropdown.Menu style={{ padding: "10px" }}>
                {userList.map((agent, index) => (
                  <Form.Check
                    key={agent.id}
                    type="checkbox"
                    id={`Checkme${index}`}
                    label={agent.name}
                    checked={selectedUsers.some(u => u.value === agent.id)}
                    onChange={() =>
                      handleSelect(agent.id, "assignedTo", agent.name)
                    }
                  />
                ))}
              </Dropdown.Menu>
          </Dropdown>

          {/* Date filters + Search button */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "8px",
            }}
          >
            <input
              type="date"
              className="border rounded px-2 py-1"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
            />
            <span>—</span>
            <input
              type="date"
              className="border rounded px-2 py-1"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
            />
            <Button
              className="primary-button"
              variant="primary"
              id="lead-search-button"
              onClick={() =>  fetchReportData()}
            >
              Search
            </Button>
          </div>
        </div>
      </div>

      <ReportsTable data={reportsData} />
    </div>
  );
};

export default Reports;
